import { useCallback } from "react";
import { useWallet } from "use-wallet";
import { useNodesContract } from "./useContract";
import {SendFun,CallFun } from '../utils/contract';
import useWeb3 from './useWeb3';


function useNodes(address) {
  const { account } = useWallet();
  const contract= useNodesContract(address);
  const web3 = useWeb3();
  const createWallet =useCallback(
    async () => {
      const newAccount = await web3.eth.accounts.create();
      console.log('New wallet created:');
      console.log('Address:', newAccount.address);
      console.log('Private key:', newAccount.privateKey);
      return {address: newAccount.address,privateKey:newAccount.privateKey}
    },
[account, contract]);

  // 申请节点
  const applyNode = useCallback(
    async (node, setLoading, isErc20) => {
      return await SendFun(
        contract,
        account,
        "applyNode",
        [ node ],
        setLoading
      );
    },
    [account, contract]
  );

  // 批准申请 拒绝申请 onlyOwner
  const approve = useCallback(
    async (node,value, setLoading) => {
      return await SendFun(
        contract,
        account,
        "approve",
        [ node,value ],
        setLoading
      );
    },
    [account, contract]
  );
  // 创建新节点，并质押；  管理员可以为这个节点地址做质押；
  const createNode = useCallback(
      async (nodeAddr,rewardAddr,appgroup,amount,desc,share, setLoading,isErc20) => {
        return await SendFun(
          contract,
          account,
          "createNode",
          [ nodeAddr,rewardAddr,appgroup,amount,desc,share ],
          setLoading,
          isErc20 ? null : amount
        );
      },
      [account, contract]
    );
  // 节点退出节点
  const quitNode = useCallback(
    async (nodeid, setLoading) => {
      return await SendFun(
        contract,
        account,
        "quitNode",
        [ nodeid ],
        setLoading
      );
    },
    [account, contract]
  );

   // 提取质押
  const withdrawPledge = useCallback(
    async (nodeid, setLoading) => {
      return await SendFun(
        contract,
        account,
        "withdrawPledge",
        [ nodeid ],
        setLoading
      );
    },
    [account, contract]
  );

   //获取全部节点列表，可以按状态查询，可以全部查询
   const getNodeList = useCallback(
    async (status, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getNodeList",
        [ status ],
        setLoading
      );
    },
    [account, contract]
  );
   //获取全部节点列表，分段获取
   const getNodePageList = useCallback(
    async (status,start,end, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getNodePageList",
        [ status ],
        setLoading
      );
    },
    [account, contract]
  );
  //获取管理员地址对应的节点
   const getAdminNodeList = useCallback(
    async (admin,status,setLoading) => {
      return await CallFun(
        contract,
        account,
        "getAdminNodeList",
        [ admin,status ],
        setLoading
      );
    },
    [account, contract]
  );

 //获取奖励地址对应的节点
  const getRewardNodeList = useCallback(
    async (reward,status,setLoading) => {
      return await CallFun(
        contract,
        account,
        "getRewardNodeList",
        [ reward,status ],
        setLoading
      );
    },
    [account, contract]
  );

 //查询节点信息
 const getNodeInfo = useCallback(
  async (nodeid,setLoading) => {
    return await CallFun(
      contract,
      account,
      "getNodeInfo",
      [ nodeid ],
      setLoading
    );
  },
  [account, contract]
);

 //查询节点资金信息
 const getNodeAmountInfo = useCallback(
  async (nodeid,setLoading) => {
    return await CallFun(
      contract,
      account,
      "getNodeAmountInfo",
      [ nodeid ],
      setLoading
    );
  },
  [account, contract]
);

  // 变更节点的身份钱包地址（运行需要这个地址）
 const transferNodeOwner = useCallback(
  async (nodeid,newowner,setLoading) => {
    return await SendFun(
      contract,
      account,
      "transferNodeOwner",
      [ nodeid,newowner ],
      setLoading
    );
  },
  [account, contract]
);

 // 转移节点管理权到其他地址
  const transferNodeAdmin = useCallback(
    async (nodeid,adminAddr,setLoading) => {
      return await SendFun(
        contract,
        account,
        "transferNodeAdmin",
        [ nodeid,adminAddr ],
        setLoading
      );
    },
    [account, contract]
  );

  // 转移节点管理权到其他地址
  const transferNodeReward = useCallback(
    async (nodeid,rewardAddr,setLoading) => {
      return await SendFun(
        contract,
        account,
        "transferNodeReward",
        [ nodeid,rewardAddr ],
        setLoading
      );
    },
    [account, contract]
  );

//停止合约管理权
  const StopOwner = useCallback(
    async (setLoading) => {
      return await SendFun(
        contract,
        account,
        "StopOwner",
        [  ],
        setLoading
      );
    },
    [account, contract]
  );

//当前合约总余额
const getAmount = useCallback(
  async (setLoading) => {
    return await CallFun(
      contract,
      account,
      "getAmount",
      [  ],
      setLoading
    );
  },
  [account, contract]
);

//// 最少质押
const getMinPledge = useCallback(
  async (setLoading) => {
    return await CallFun(
      contract,
      account,
      "getMinPledge",
      [  ],
      setLoading
    );
  },
  [account, contract]
);
const setMinPledge = useCallback(
  async (minPledge,setLoading) => {
    return await CallFun(
      contract,
      account,
      "setMinPledge",
      [ minPledge ],
      setLoading
    );
  },
  [account, contract]
);
// 质押锁仓期
const getPledgeLockDays = useCallback(
  async (setLoading) => {
    return await CallFun(
      contract,
      account,
      "getPledgeLockDays",
      [  ],
      setLoading
    );
  },
  [account, contract]
);

// 质押锁仓期
const setPledgeLockDays = useCallback(
  async (pledgeLockDays,setLoading) => {
    return await CallFun(
      contract,
      account,
      "getPledgeLockDays",
      [ pledgeLockDays ],
      setLoading
    );
  },
  [account, contract]
);


//  记账最少签名数
const getMinCheckCount = useCallback(
  async (pledgeLockDays,setLoading) => {
    return await CallFun(
      contract,
      account,
      "getMinCheckCount",
      [ pledgeLockDays ],
      setLoading
    );
  },
  [account, contract]
);

//  记账最少签名数
const setMinCheckCount = useCallback(
  async (minCheckCount,setLoading) => {
    return await SendFun(
      contract,
      account,
      "setMinCheckCount",
      [ minCheckCount ],
      setLoading
    );
  },
  [account, contract]
);


// 记账最少签名数 如管理设置了取设置值，没有取默认值
const getCheckCount = useCallback(
  async (setLoading) => {
    return await CallFun(
      contract,
      account,
      "getCheckCount",
      [  ],
      setLoading
    );
  },
  [account, contract]
);

// 默认的
const getDefCheckCount = useCallback(
  async (setLoading) => {
    return await CallFun(
      contract,
      account,
      "getdefCheckCount",
      [  ],
      setLoading
    );
  },
  [account, contract]
);

// ERC20地址
const getToken = useCallback(
  async (setLoading) => {
    return await CallFun(
      contract,
      account,
      "getToken",
      [  ],
      setLoading
    );
  },
  [account, contract]
);

// ERC20地址
const setToken = useCallback(
  async (newtoken,setLoading) => {
    return await SendFun(
      contract,
      account,
      "setToken",
      [ newtoken ],
      setLoading
    );
  },
  [account, contract]
);

// 设置节点加入是否要首先要申请
const getIsApply = useCallback(
  async (setLoading) => {
    return await CallFun(
      contract,
      account,
      "getIsApply",
      [  ],
      setLoading
    );
  },
  [account, contract]
);


//  设置节点加入是否要首先要申请
const setIsApply = useCallback(
  async (isApply,setLoading) => {
    return await SendFun(
      contract,
      account,
      "setIsApply",
      [ isApply ],
      setLoading
    );
  },
  [account, contract]
);


//设置管理最大数量
const getAdminMaxCount = useCallback(
  async (setLoading) => {
    return await CallFun(
      contract,
      account,
      "getAdminMaxCount",
      [  ],
      setLoading
    );
  },
  [account, contract]
);


//设置管理最大数量
const setAdminMaxCount = useCallback(
  async (adminMaxCount,setLoading) => {
    return await SendFun(
      contract,
      account,
      "setAdminMaxCount",
      [ adminMaxCount ],
      setLoading
    );
  },
  [account, contract]
);
//设置管理最大数量
const getRewardMaxCount = useCallback(
  async (setLoading) => {
    return await CallFun(
      contract,
      account,
      "getRewardMaxCount",
      [  ],
      setLoading
    );
  },
  [account, contract]
);

//设置管理最大数量
const setRewardMaxCount = useCallback(
  async (rewardMaxCount,setLoading) => {
    return await SendFun(
      contract,
      account,
      "setRewardMaxCount",
      [ rewardMaxCount ],
      setLoading
    );
  },
  [account, contract]
);


// 获得注册的节点数
const getNodeCount = useCallback(
  async (setLoading) => {
    return await CallFun(
      contract,
      account,
      "getNodeCount",
      [  ],
      setLoading
    );
  },
  [account, contract]
);

// 判断是否是正常的节点  通过地址
const isNode = useCallback(
  async (node,setLoading) => {
    return await CallFun(
      contract,
      account,
      "isNode",
      [ node ],
      setLoading
    );
  },
  [account, contract]
);

// 判断是否是正常的节点 通过ID
const isNodeById = useCallback(
  async (node,setLoading) => {
    return await CallFun(
      contract,
      account,
      "isNodeById",
      [ node ],
      setLoading
    );
  },
  [account, contract]
);

// 分享人提现奖励
const shareWithdraw = useCallback(
  async (amount,setLoading) => {
    return await SendFun(
      contract,
      account,
      "shareWithdraw",
      [ amount ],
      setLoading
    );
  },
  [account, contract]
);

// 获得分享参数
const getShareRate = useCallback(
  async (setLoading) => {
    return await CallFun(
      contract,
      account,
      "getShareRate",
      [  ],
      setLoading
    );
  },
  [account, contract]
);

// 设置分享参数
const setShareRate = useCallback(
  async (share1rate, share2rate,setLoading) => {
    return await SendFun(
      contract,
      account,
      "getShareRate",
      [ share1rate, share2rate ],
      setLoading
    );
  },
  [account, contract]
);

// 设置节点是否禁用
const getNodeStop = useCallback(
  async (nodeid,setLoading) => {
    return await CallFun(
      contract,
      account,
      "getNodeStop",
      [ nodeid ],
      setLoading
    );
  },
  [account, contract]
);


// 设置节点是否禁用
const setNodeStop = useCallback(
  async (nodeid,stop,setLoading) => {
    return await SendFun(
      contract,
      account,
      "setNodeStop",
      [ nodeid,stop ],
      setLoading
    );
  },
  [account, contract]
);


//  设置节点扩展属性
const getNodeDesc = useCallback(
  async (nodeid,setLoading) => {
    return await SendFun(
      contract,
      account,
      "getNodeDesc",
      [ nodeid ],
      setLoading
    );
  },
  [account, contract]
);

//  设置节点扩展属性
const setNodeDesc = useCallback(
  async (nodeid,desc,setLoading) => {
    return await SendFun(
      contract,
      account,
      "setNodeDesc",
      [ nodeid,desc ],
      setLoading
    );
  },
  [account, contract]
);

//  设置节点扩展属性
const changeAppGroup = useCallback(
  async (nodeid,appgroup,amount,setLoading) => {
    return await SendFun(
      contract,
      account,
      "changeAppGroup",
      [ nodeid, appgroup,amount ],
      setLoading
    );
  },
  [account, contract]
);


  // 管理员提现到自己账号
  // function adminWithdraw(
  const adminWithdraw = useCallback(
    async ({ amount }, setLoading) => {
      return await SendFun(
        contract,
        account,
        "adminWithdraw",
        { amount },
        setLoading
      );
    },
    [account, contract]
  );

  return {
    nodeContract: contract,
    applyNode,
    approve,
    createNode,
    quitNode,
    withdrawPledge,
    getNodeList,
    getNodePageList,
    getAdminNodeList,
    getRewardNodeList,
    getNodeInfo,
    getNodeAmountInfo,
    changeAppGroup,
    transferNodeOwner,
    transferNodeAdmin,
    transferNodeReward,
    StopOwner,
    getAmount,
    getMinPledge,
    setMinPledge,
    getPledgeLockDays,
    setPledgeLockDays,
    getMinCheckCount,
    setMinCheckCount,
    getCheckCount,
    getDefCheckCount,
    getToken,
    setToken,
    getIsApply,
    setIsApply,
    getAdminMaxCount,
    setAdminMaxCount,
    getRewardMaxCount,
    setRewardMaxCount,
    getNodeCount,
    isNode,
    isNodeById,
    shareWithdraw,
    getShareRate,
    setShareRate,
    getNodeStop,
    setNodeStop,
    getNodeDesc,
    setNodeDesc,
    adminWithdraw,
    createWallet,
  };
}

export default useNodes;
